import { Language, Theme } from '@metadevprofile/shared';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/common/redux/store';

export interface PreferencesState {
  language: Language;
  theme: Theme;
}

const initialState: PreferencesState = {
  language: Language.EN,
  theme: Theme.SYSTEM,
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
    },
    setPreferences: (state, action: PayloadAction<Partial<PreferencesState>>) => {
      Object.assign(state, action.payload);
    },
    resetPreferences: () => initialState,
  },
});

export const { setTheme, setLanguage, setPreferences, resetPreferences } = preferencesSlice.actions;
export const preferencesReducer = preferencesSlice.reducer;

export const selectLanguage = (state: RootState): Language => state.preferences.language;
export const selectTheme = (state: RootState): Theme => state.preferences.theme;
